import { useT } from '@kmgestao/i18n';

import { getClinicStatusStyle } from '../../../features/clinics/index.js';

/**
 * Badge visual do status da clínica. Reutiliza tokens centralizados de
 * `clinic-status-style.ts` — mesmo padrão do `LeadStageBadge` e do
 * helper de propostas. Light + dark sem hardcode.
 *
 * Labels e `aria-label` vêm do namespace `clinics` (i18n) — regra
 * inviolável §5.3 do AGENTS.md.
 */
export function ClinicStatusBadge({ status }: { status: string }) {
  const { t } = useT('clinics');
  const style = getClinicStatusStyle(status);
  // i18next devolve a chave bruta quando não acha — fallback pro status
  // raw mantém UI legível mesmo com valor desconhecido vindo do banco.
  const label = t(`status.${status}`, { defaultValue: status });
  return (
    <span
      className={style.badgeClassName}
      role="status"
      aria-label={t('status.ariaLabel', { label })}
    >
      {style.icon ? <span aria-hidden="true">{style.icon}</span> : null}
      {label}
    </span>
  );
}
